import { isMeterColorKey, METER_COLOR_PALETTE } from "@next-platform/packages-ts-types";
/** Resolves a meter color palette key to the hex value for the given theme; undefined stays undefined. */
export default function resolveMeterColor({ color, theme }) {
    return isMeterColorKey(color) ? METER_COLOR_PALETTE[color][theme] : undefined;
}
